import React from "react";
import logo1 from "../../assets/logos/logo1.jpg";
import logo2 from "../../assets/logos/logo2.jpg";
import logo3 from "../../assets/logos/logo3.jpg";
import logo4 from "../../assets/logos/logo4.jpg";
import logo5 from "../../assets/logos/logo5.jpg";
import "../../styles/Certification.css";

const CertificationSection = () => {
  const logos = [logo1, logo2, logo3, logo4, logo5];

  return (
    <section className="certification-section">
      <div className="certification-container">
        {/* <span className="mini-title">Certifications</span> */}
        <br />
        <br />
        <h2 className="certification-title">Our Certifications</h2>
        <div className="logos-slider">
          <div className="logos-track">
            {[...logos, ...logos].map((logo, index) => (
              <div className="logo-item" key={index}>
                <img src={logo} alt={`Certification Logo ${index + 1}`} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CertificationSection;
